import { formatDate } from "@angular/common";
import { effect, inject, Injectable, LOCALE_ID, untracked } from "@angular/core";
import { DatepickerDefaults } from "@dcc/ui-kit/datepicker";
import { UserStore } from "@dcc/vestas-online/data-access";

@Injectable()
export class CustomDatePickerDefaults extends DatepickerDefaults {
    private userStore = inject(UserStore);
    private _locale: string = inject(LOCALE_ID);

    public override ariaDateFormat = "MMMM d, yyyy";

    public override altFormat = this.userStore.dateFormat();

    constructor() {
        super();

        effect(() => {
            const format = this.userStore.dateFormat();

            untracked(() => {
                this.altFormat = format;
            });
        });
    }

    public override formatDate = (date: Date, format: string): string => {
        if (format === "Z") {
            return date.toISOString();
        }
        return formatDate(date, format, this._locale);
    };
}
